module.exports = __webpack_public_path__ + "static/media/pla_black_cocktail_straw3.772721df.png";